export const navLogo = {
    img: require('../../images/svg-1.svg'),
    alt: 'Expert'
}